var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"error-results-block"},[_c('h2',{staticClass:"error-results-block__title"},[_vm._v(" "+_vm._s(_vm.registerTitle)+" ")]),_c('div',{staticClass:"error-results-block__error"},[_c('h3',[_vm._v(_vm._s(_vm.$t('resultsError.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('resultsError.body')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }